import moment from 'moment';
import callApi from '../../util/apiCaller';
import { FETCH_LIMIT, getItemsRequest, sendSocket } from '../App/AppActions';
import { getApplicantId } from '../Applicant/ApplicantActions';
import { getSessionId } from '../Session/SessionActions';
import { getModelEvent } from '../Model/ModelHelpers';

export const SET_CORRECTIONS = 'SET_CORRECTIONS';
export const SET_SESSION_CORRECTIONS = 'SET_SESSION_CORRECTIONS';

export function getSessionCorrectionsRequest(sessionId) {
    return dispatch => dispatch(getItemsRequest(`session/${sessionId}/corrections`, 'corrections', items => dispatch(setSessionCorrections(sessionId, items)), { pager: { size: FETCH_LIMIT * 5 } }, { isRecursive: true }));
}

export function getApplicantCorrectionsRequest(applicantId) {
    return dispatch => {
        return callApi(`applicant/${applicantId}/corrections`).then(result => {
            dispatch(setCorrections(applicantId, result.corrections));
            return result.corrections;
        }).catch(err => {
            return null;
        });
    };
}

export function editCorrectionRequest(applicant, correction, isMassAction = false) {
    return dispatch => {
        return callApi('correction/edit', 'post', { correction }).then(result => {
            if(!isMassAction && result.correction) {
                dispatch(getApplicantCorrectionsRequest(correction.applicant));
                dispatch(sendSocket({ type: 'correction/edit', data: { session: getSessionId(applicant.session), applicant: getApplicantId(applicant) } }));
            }
            return result.correction;
        }).catch(err => {
            console.error(err);
            return null;
        });
    };
}

export function getCorrections(store, applicantId) {
    return store.corrections.byApplicant[applicantId];
}
export function getSessionCorrections(store, sessionId) {
    return store.corrections.bySession[sessionId];
}

export function getValidCorrections(applicant, corrections = [], corrector = null, log = false) {
    // log && console.log('corrections to validated', corrections);
    return (applicant?.selectedQuestions?.questions || []).map(questionOrQuestionId => {
        const questionId = (questionOrQuestionId?._id || questionOrQuestionId).toString();
        // log && questionId === '67ea942bbb32e3116afed38f' && console.log('questionId', questionOrQuestionId, questionId, questionId === '67ea942bbb32e3116afed38f', [...(corrections || []).filter(correction => correction?.question?.toString() === questionId)]);
        return getValidCorrection((corrections || []).filter(correction => correction?.question?.toString() === questionId), corrector /* log && questionId === '67ea942bbb32e3116afed38f' */);
    }).filter(c => c);
}

export function getValidCorrection(questionCorrections, corrector = null, log = false) {
    let questionCorrection = null;

    log && console.log('questionCorrectionsAvailable', questionCorrections);
    if(questionCorrections.filter(availableCorrection => availableCorrection.status === 'validated').length === 1) { // if only one correction validated
        log && console.log('Correction selection:: 1 validated found');
        [questionCorrection] = questionCorrections.filter(availableCorrection => availableCorrection.status === 'validated');
    } else if(questionCorrections.filter(availableCorrection => availableCorrection.status === 'validated').length > 1) { // if multiple validated corrections => select last corrected
        questionCorrections = questionCorrections.filter(availableCorrection => availableCorrection.status === 'validated').sort((cA, cB) => new Date(getModelEvent(cB, 'validated', 'last')?.date) - new Date(getModelEvent(cA, 'validated', 'last')?.date));
        log && console.log('Correction selection:: 2+ validated found', questionCorrections);
        [questionCorrection] = questionCorrections;
    } else if(corrector && questionCorrections.find(correction => correction?.corrector === corrector)) {
        questionCorrection = questionCorrections.find(correction => correction?.corrector === corrector);
        log && console.log('Correction selection:: corrector found');
    } else if(questionCorrections.length === 1) { // if only one correction
        log && console.log('Correction selection:: only 1 found');
        [questionCorrection] = questionCorrections;
    } else {
        log && console.log('Correction selection:: none found', questionCorrections);
    }

    // else do not select any other corrections (pending or multi validated)
    log && questionCorrection && console.log('ValidCorrection found for question', questionCorrection);
    return questionCorrection;
}

export function setSessionCorrections(sessionId, corrections) {
    return {
        type: SET_SESSION_CORRECTIONS,
        sessionId,
        corrections,
    };
}

export function setCorrections(applicantId, corrections) {
    return {
        type: SET_CORRECTIONS,
        applicantId,
        corrections,
    };
}
